import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface CategoriesReducer {
    categories: any[] | null;
}

const initialState: CategoriesReducer = {
    categories: null,
};

const categoriesReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.CATEGORIES.SEARCH_CATEGORY:
            return {
                ...state,
                categories: action.payload,
            };

        default:
            return state;
    }
};

export default categoriesReducer;
